import React from "react";
import { Menu, Container, Image, Dropdown, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../../app/store/actions/authActions";
import {
  MENU_CONSULTAS_CONTENT,
  MENU_CONSULTAS_SM_CREDITOS_CONTENT,
  MENU_CONSULTAS_SM_CUENTAS_CONTENT,
  MENU_INICIO_CONTENT,
  MENU_MIS_OFERTAS_CONTENT,
  MENU_MIS_OFERTAS_SM_CAMPANIAS_CONTENT,
  MENU_OPERACIONES_CONTENT,
  MENU_OPERACIONES_SM_APERTURA_CONTENT,
  MENU_OPERACIONES_SM_PAGOS_CONTENT,
  MENU_OPERACIONES_SM_TRANSFERENCIAS_CONTENT,
  // MENU_SEGURIDAD_CLAVE_SMS_CONTENT,
  MENU_SEGURIDAD_SESIONES_CONTENT,
  MENU_SEGURIDAD_LOGOUT_CONTENT,
} from "../../app/infrastructure/appConstants";

const mapState = (state) => ({
  currentUser: state.auth.currentUser,
});

const actions = {
  logout,
};

const MenuUsuarioDesktop = ({ currentUser, logout }) => {
  return (
    <Menu fixed="top" secondary size="massive" className="navBarPrymera">
      <Container>
        <Menu.Item header position="left">
          <Image src="/assets/images/logo-prymera.svg" size="small" />
        </Menu.Item>

        <Menu.Item name={MENU_INICIO_CONTENT} as={Link} to="/inicio" />

        <Dropdown item text={MENU_MIS_OFERTAS_CONTENT}>
          <Dropdown.Menu>
            <Dropdown.Item
              text={MENU_MIS_OFERTAS_SM_CAMPANIAS_CONTENT}
              as={Link}
              to="/campanias"
            />
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown item text={MENU_CONSULTAS_CONTENT}>
          <Dropdown.Menu>
            <Dropdown.Item
              text={MENU_CONSULTAS_SM_CREDITOS_CONTENT}
              as={Link}
              to="/prestamos"
            />
            <Dropdown.Item
              text={MENU_CONSULTAS_SM_CUENTAS_CONTENT}
              as={Link}
              to="/cuentas"
            />
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown item text={MENU_OPERACIONES_CONTENT}>
          <Dropdown.Menu>
            <Dropdown.Item
              text={MENU_OPERACIONES_SM_PAGOS_CONTENT}
              as={Link}
              to="/pagar-prestamos"
            />
            <Dropdown.Item
              text={MENU_OPERACIONES_SM_APERTURA_CONTENT}
              as={Link}
              to="/aperturar-cuenta"
            />
            <Dropdown.Item
              text={MENU_OPERACIONES_SM_TRANSFERENCIAS_CONTENT}
              as={Link}
              to="/transferencias"
            />
          </Dropdown.Menu>
        </Dropdown>

        <Menu.Item position="right">
          <Icon name="user outline" />
          <Dropdown
            pointing="top left"
            text={`Hola: ${
              currentUser
                ? currentUser.primerNombre
                  ? currentUser.primerNombre
                  : currentUser.apellidoPaterno
                : ``
            }`}
          >
            <Dropdown.Menu>
              {/* <Dropdown.Item text={`Último acceso: ${currentUser.fechaUltimaAcceso}`} /> */}
              {/* <Dropdown.Item
                text={MENU_SEGURIDAD_CLAVE_SMS_CONTENT}
                icon="key"
                as={Link}
                to="/afiliacion"
              /> */}
              <Dropdown.Item
                text={MENU_SEGURIDAD_SESIONES_CONTENT}
                icon="laptop"
                as={Link}
                to="/sesiones"
              />
              <Dropdown.Item
                text={MENU_SEGURIDAD_LOGOUT_CONTENT}
                icon="log out"
                onClick={logout}
              />
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Item>
      </Container>
    </Menu>
  );
};

export default connect(mapState, actions)(MenuUsuarioDesktop);
